import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { HomePage } from '../home/home'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { DataExchanger } from '../../providers/data-exchanger';
import { GamerulesModel } from '../../providers/gamerules-model';

@Component({
  selector: 'page-rankings',
  templateUrl: 'rankings.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class RankingsPage {
  rankings:any;
  currentLevelProgress:number;
  currentLevel:number;
  rankingsAverageEntropy:any;

  constructor(public functions: Functions, public dataExchanger: DataExchanger, public rubedoSideMenu: MenuController, public translate: TranslateService, public navCtrl: NavController, public gamesrulesModel: GamerulesModel) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
    this.currentLevelProgress=0;
    this.currentLevel=1;

    this.dataExchanger.getRankingsFromServer().then((response)=>{
      this.rankings=response;
      for (let i = 0; i < this.rankings.length; i++) {
        //console.log("rankings["+i+"]: "+JSON.stringify(this.rankings[i]));
        this.rankings[i].currentLevel=this.gamesrulesModel.getLevelFromScore(this.rankings[i].score);
        this.rankings[i].currentLevelProgress=this.gamesrulesModel.getProgressInLevelFromScore(this.rankings[i].score);
      }
    });

    this.dataExchanger.getRankingsAverageEntropyFromServer().then((response)=>{
      this.rankingsAverageEntropy=response;
    });
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/rankings/rankings.ts